import { useState, useCallback } from "react";

/**
 * Like useState, but persists to sessionStorage so values survive
 * component unmount / remount during SPA navigation.
 *
 * @param {string} key   Unique key under the "sramika_" namespace
 * @param {*}      init  Default value (used when nothing is stored)
 */
export default function useSessionState(key, init) {
  const storageKey = `sramika_ss_${key}`;

  const [value, setValue] = useState(() => {
    try {
      const raw = sessionStorage.getItem(storageKey);
      if (raw !== null) return JSON.parse(raw);
    } catch { /* ignore parse errors */ }
    return typeof init === "function" ? init() : init;
  });

  const set = useCallback(
    (next) => {
      setValue((prev) => {
        const resolved = typeof next === "function" ? next(prev) : next;
        try {
          sessionStorage.setItem(storageKey, JSON.stringify(resolved));
        } catch { /* storage full - silently skip */ }
        return resolved;
      });
    },
    [storageKey]
  );

  return [value, set];
}
